<template>
  <div>
    <div v-if="hasActiveMarkets">
      <RevCard class="p-24 md:p-32">
        <h2 class="heading-2">{{ i18n(translations.title) }}</h2>

        <h3 class="heading-3 mt-16">
          {{ i18n(translations.opened) }}
        </h3>
        <MarketsGrid
          :aria-label="i18n(translations.opened)"
          :markets="activeMarkets"
          with-active-markets
        />

        <div v-if="hasPotentialMarkets" class="mt-32">
          <h3 class="heading-3">
            {{ i18n(translations.openable) }}
          </h3>
          <MarketsGrid
            :aria-label="i18n(translations.openable)"
            :markets="potentialMarkets"
          />
        </div>
      </RevCard>

      <div class="grid-standard mt-32 h-full">
        <ActivityReach :value="activityReach" />

        <OpenMarkets :can-open-new-markets :has-potential-markets />
      </div>
    </div>

    <EmptyState v-if="!hasActiveMarkets" :potential-markets />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Markets.translations'
import ActivityReach from './components/ActivityReach/ActivityReach.vue'
import EmptyState from './components/EmptyState/EmptyState.vue'
import MarketsGrid from './components/MarketsGrid/MarketsGrid.vue'
import OpenMarkets from './components/OpenMarkets/OpenMarkets.vue'

const i18n = useI18n()

const { canOpenNewMarkets, activeMarkets, potentialMarkets } =
  useSellerInfoStore()

const hasActiveMarkets = computed(() => activeMarkets.length > 0)
const hasPotentialMarkets = computed(() => potentialMarkets.length > 0)

const activityReach = computed(() => {
  const value =
    (activeMarkets.length / (activeMarkets.length + potentialMarkets.length)) *
    100

  // since ChartCircle expect a Number and toFixed return a string, we need to convert it to a number again
  return Number(value.toFixed(2))
})
</script>
